import * as interviews from './services/InterviewService';
import loadForm from "./form-helper";
import * as calendar from "./services/CalendarService";
import moment from "moment/moment";

loadForm('interview-application', (data) => {
    interviews.confirmInvitation(Jobtoolz.api.invitationId, data).then(res => {
        window.location.href = Jobtoolz.urls.success;
    }).catch(e => {
        const errors = document.getElementById('errors');
        const errorAttributes = e.response.data.errors

        const error =
            errorAttributes['attributes.status'] ||
            errorAttributes['attributes.slot'] ||
            errorAttributes['attributes.available'] ||
            errorAttributes['attributes.slotTime'];

        if (error) {
            errors.querySelector('.content').innerHTML = error;
        }

        errors.classList.remove('hidden');
    })
})

let timeslots = [];

if (Jobtoolz.api.interview) {
    timeslots = Jobtoolz.api.timeslots.map(slot => {
        return {
            start: moment(slot.starttime),
            end: moment(slot.endtime),
            available: slot.available
        }
    })

    timeslots = timeslots.filter(slot => new Date(slot.start) > new Date() && !!slot.available);
}

let cronofyDateTimePicker = document.getElementById('cronofy-date-time-picker');

if (cronofyDateTimePicker) {
    const invitationId = Jobtoolz.api.invitationId;
    const interview = Jobtoolz.api.interview;

    let start, end;
    let CronofyMembers = [];
    Jobtoolz.api.cronofyMembers.forEach(member => {
        if (member.sub) {
            CronofyMembers.push(member);
        }
    })

    if (interview.calendar_open) {
        start = moment(interview.calendar_time_range.start)
            .set({hour:0,minute:0,second:0,millisecond:0})
            .format();
        end = moment(interview.calendar_time_range.end)
            .set({hour:23,minute:59,second:59,millisecond:0})
            .format();

        if (start <= moment().format()) {
            start = moment().add(1, 'hours').format();
        }

        if (end <= start) {
            end = moment().add(1, 'hours').format();
        }
    }

    calendar.token({scopes: ['availability'], invitationId}).then(data => {
        CronofyElements.DateTimePicker({
            element_token: data?.token,
            target_id: 'cronofy-date-time-picker',
            response_format: interview.calendar_open ? 'overlapping_slots' : 'slots',
            availability_query: {
                participants: [
                    {
                        required: "all",
                        members: CronofyMembers,
                    }
                ],
                required_duration: { minutes: interview.duration },
                start_interval: { minutes: interview.calendar_open ? 15 : 5 },
                query_periods: interview.calendar_open ? [{start: start, end:  end}] : timeslots,
            },
            data_center: 'de',
            locale: Jobtoolz.api.locale,
            callback(data) {
                const notification = data.notification;
                let xhrData = {};

                if (notification.type === "slot_selected") {
                    document.getElementById("cronofy-overlay").classList.remove('hidden');

                    const cronofySlot = notification.slot;

                    if (!interview.calendar_open) {
                        const JTSlot = Jobtoolz.api.timeslots.find(slot => moment(slot.starttime).isSame(moment(cronofySlot.start)))

                        xhrData = {
                            attributes: {
                                slot_id: JTSlot.id,
                                slotTime: JTSlot.starttime_original,
                                available: true
                            },
                            type: 'interview-application'
                        }
                    } else {
                        xhrData = {
                            attributes: {
                                slotTime: cronofySlot.start,
                                available: true
                            },
                            type: 'interview-application'
                        }
                    }

                    interviews.confirmInvitation(invitationId, xhrData).then(() => {
                        window.location.replace(Jobtoolz.urls.success);
                    })
                }
            },
        });
    });
}
